import React from 'react';
import { CLASSIFIEDS_VIEW } from 'MODULES/CLASSIFIEDS_VIEW';
import { isMobile } from 'react-device-detect';
import { setIsToggled } from 'ACTIONS/ui/setIsToggled';
import { UI } from 'CONST';
import { switchView } from 'ACTIONS/ui/switchView';
import { useDispatch } from 'react-redux';


export const ListButtons = ({ viewType, i18n }) => {
    const isGridOrClothes = viewType === CLASSIFIEDS_VIEW.grid || viewType === CLASSIFIEDS_VIEW.clothes;
    const ariaLabel = isGridOrClothes ? i18n.__('Switch to list view') : i18n.__('Switch to grid view');

    const dispatch = useDispatch();
    return (
        <button
            onClick={() => {
                dispatch(switchView(isGridOrClothes ? CLASSIFIEDS_VIEW.list : CLASSIFIEDS_VIEW.grid));
                dispatch(setIsToggled(UI.FILTER_BLOCK_MOBILE, false));
            }}
            className={isMobile ? 'btn btn-secondary pp-block form-check w-100 mb-2 d-flex align-items-center justify-content-center' : 'btn btn-action btn-sort ms-1'}
            type="button"
            aria-label={i18n.__(ariaLabel)}
        >
            <i
                className={`pp-ico p-0 ${isMobile ? 'me-2' : ''} ${isGridOrClothes ? 'pp-list' : 'pp-th'}`}
                aria-hidden="true"
            />
            {isMobile && (
                <span>{ariaLabel}</span>
            )}
        </button>
    );
};

export default ListButtons;
